export enum ScopeAccess {
  Transport = 'transport',
  StudentPlans = 'student-plans',
  MakePayments = 'make-payments',
}
